export const getDepartmentSlug = roleId => {
	const role = Number(roleId);

	switch (role) {
		case 1:
		case 5:
			return 'emergencydm';
		case 2:
		case 6:
			return 'surgerydm';
		case 3:
		case 7:
			return 'criticalcaredm';
		case 4:
		case 8:
			return 'stepdowndm';
		default:
			return 'join';
	}
};

